module.exports = __webpack_public_path__ + "img/faixa3.832cb800.png";